import { createSelector } from "@ngrx/store";
import { AppState } from "../../app.state";

export const selectAcuerdoState = ( state: AppState ) => state.acuerdo;
export const selectAcuerdo = createSelector(selectAcuerdoState, (state) => state);